import classnames from 'classnames'
import { useTranslation } from 'next-i18next'
import React, { useCallback, useState } from 'react'

import { OptionProp } from '../OptionSelector.constant'

import styles from './inputOption.module.scss'

const REGEX_PATTERN = /^[A-Za-z]*$/

const InputOption = ({
  onChange,
  maxCharacterLimit,
  minCharacterLimit,
}: Pick<OptionProp, 'onChange' | 'maxCharacterLimit' | 'minCharacterLimit'>) => {
  const { t } = useTranslation('common')
  const [inputText, setInputText] = useState('')
  const [errorText, setErrorText] = useState<string | null>(null)

  const placeholderText =
    maxCharacterLimit === minCharacterLimit
      ? t('enter_var1_characters', { var1: minCharacterLimit })
      : t('enter_up_to_var1_characters', { var1: maxCharacterLimit })

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      let value = e.target.value
      const isValidText = REGEX_PATTERN.test(value)

      // Capitalize all letters if minCharacterLimit === maxCharacterLimit
      if (minCharacterLimit === maxCharacterLimit) {
        value = value.toUpperCase()
      } else value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
      if (value.length === 0) setErrorText(null)
      if (value.length > 0) {
        if (!isValidText) {
          setErrorText(t('only_letters_allowed'))
        } else if (maxCharacterLimit && value.length > maxCharacterLimit) {
          setErrorText(t('maximum_characters_var1_allowed', { var1: maxCharacterLimit }))
        } else setErrorText(null)
      }
      setInputText(value)
      onChange?.(value)
    },
    [minCharacterLimit, maxCharacterLimit],
  )

  return (
    <div className={styles.inputOptionWrapper}>
      <input
        className={classnames(styles.option)}
        onChange={e => {
          handleChange(e)
        }}
        placeholder={placeholderText}
        value={inputText}
        // onBlur={handleOnblur}
      />
      {errorText ? <div className={styles.errorMsg}>{errorText}</div> : ''}
    </div>
  )
}

export default InputOption
